export interface ContactDetails {
    address1?: string;
    address2?: string;
    city: string;
    committeeId?: number;
    committeeTypeId?: number;
    committee?: string | number;
    contactId?: number;
    contactTypeId?: number;
    contactType?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    occupation?: string;
    orgName?: string;
    phone?: string;
    roleName?: string;
    stateCode: string;
    voterId?: string | number;
    zip: string;
    fullName?: string; 
    hasTransaction?: boolean;
}
